export function transformLog(log, data) {
  switch (log) {
    default:
      return data.map((item) => ({
        ...item,
        date: new Date(item.date),
      }));
  }
}
